import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@vant/touch-emulator'

// Import utilities
import http from './utils/request.js'
import { getStorageSync, setStorageSync } from './utils/storage.js'
import { setRouter } from './utils/navigation.js'
import { getSystemInfoSync } from './utils/system.js'
import { useAppStore } from './store/index.js'
// Import uni compatibility layer
import './utils/uni-compat.js'

// Import constants
import { description } from '../package.json'
import {
  getLanguageListURL,
} from './common/js/constants.js'
import {
  getSystemBaseURL,
  getLine1URL,
  getLine2URL
} from './common/js/static-constants.js'

// Import locale
import zhLocale from './locales/zh.js'
import moment from 'moment-timezone'

// Create Pinia store
const pinia = createPinia()

// Create i18n
const i18n = createI18n({
  locale: getStorageSync('lang') || 'zh',
  fallbackLocale: 'zh',
  messages: {
    'zh': zhLocale,
  },
  silentTranslationWarn: true,
  legacy: false,
})

// Create Vue app
const app = createApp(App)

// Use plugins
app.use(router)
app.use(pinia)
app.use(i18n)
app.use(Vant)

// Set router in navigation utility
setRouter(router)

// Global properties
app.config.globalProperties.$getLocalTime = function(datetime) {
  const d = moment.tz(datetime, "Asia/Shanghai")
  const localtz = moment.tz.guess()
  const date = d.clone().tz(localtz)
  return moment(date).format("YYYY-MM-DD HH:mm:ss")
}

app.config.globalProperties.$themeBase = ""

app.config.globalProperties.$setDefaultAddress = function() {
  const line = getStorageSync('selectedLine')
  if (!line || line === '') {
    setStorageSync('selectedLine', getSystemBaseURL())
    setStorageSync('selectedLineFirstTime', '0')
  }
}

// Load language async
app.config.globalProperties.$loadLangAsync = function(lang) {
  return new Promise((resolve) => {
    setTimeout(() => {
      http({
        url: getLanguageListURL(lang),
        method: "post",
      }, (errorMsg) => {
        console.log('Failed to retrieve language list')
        resolve(false)
      }).then((res) => {
        if (res.status === 200) {
          i18n.global.locale.value = lang
          app.config.globalProperties.$langLoaded = true
          i18n.global.setLocaleMessage(lang, res.data)
          setStorageSync('lang', lang)
          resolve(true)
        } else {
          setStorageSync('lang', lang)
          resolve(false)
        }
      }).catch(() => {
        resolve(false)
      })
    }, 1500)
  })
}

// Set default address (will be called after app is created)
// app.config.globalProperties.$setDefaultAddress()

// Load language (will be called after app is created)
// const systemLang = getStorageSync('lang')
// app.config.globalProperties.$loadLangAsync(systemLang === '' ? 'zh' : systemLang)

// HTTP instance
app.config.globalProperties.http = http

// Store instance
app.config.globalProperties.$store = useAppStore()

// URLs for API line selection
const baseUrl = getSystemBaseURL() + '/app/Home/apitest'
const line1Url = getLine1URL() + '/app/Home/apitest'
const line2Url = getLine2URL() + '/app/Home/apitest'

const urls = [
  { "id": 1, "name": "线路 1", "url": baseUrl },
  { "id": 2, "name": "线路 2", "url": line1Url },
  { "id": 3, "name": "线路 3", "url": line2Url }
]

app.config.globalProperties.$URLs = urls

// Make router and i18n available globally
if (typeof window !== 'undefined') {
  window.__VUE_ROUTER__ = router
  window.__VUE_I18N__ = i18n
}

// Initialize API lines
const lines = urls

async function getApisFromApi() {
  // API fetching logic (currently commented out in original)
  // Can be implemented later if needed
}

function checkDuplicateUrls(url) {
  let isDuplicate = false
  for (let eachLine = 0; eachLine < lines.length; eachLine++) {
    if (lines[eachLine].url === url) {
      isDuplicate = true
      break
    }
  }
  return isDuplicate
}

async function initialize() {
  await getApisFromApi()

  const buildNumber = getStorageSync("buildNumber")
  const fixedLines = getStorageSync("fixedLines")

  if (!buildNumber || buildNumber === "") {
    setStorageSync("buildNumber", description)
  }

  setStorageSync("initialLines", JSON.stringify(lines))

  if (buildNumber !== description || !fixedLines || fixedLines === "") {
    setStorageSync("fixedLines", JSON.stringify(lines))
  }
}

// Mount app first
app.mount('#app')

// Initialize after mount
initialize().then(() => {
  // Set default address after initialization
  app.config.globalProperties.$setDefaultAddress()
  
  // Load language after initialization
  const systemLang = getStorageSync('lang')
  app.config.globalProperties.$loadLangAsync(systemLang === '' ? 'zh' : systemLang)
})

